import { useEffect } from 'react';

const SITE = 'https://awaazup.in';
const DESC = 'A gentle daily companion that grows with your consistency — choose a tree, a creature, a collection, or a constellation, and keep it going.';

function setTag(selector, attr, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith('link') ? 'link' : 'meta');
    if (selector.startsWith('link')) el.setAttribute('rel', 'canonical');
    else if (selector.includes('property=')) el.setAttribute('property', selector.match(/property="(.+?)"/)[1]);
    else if (selector.includes('name=')) el.setAttribute('name', selector.match(/name="(.+?)"/)[1]);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

// Sets tab title + canonical + og:url/og:title for the current route (client-side).
export function useMeta({ title, path = '' }) {
  useEffect(() => {
    const url = `${SITE}${path}`;
    document.title = title;
    setTag('link[rel="canonical"]', 'href', url);
    setTag('meta[property="og:url"]', 'content', url);
    setTag('meta[property="og:title"]', 'content', title);
    setTag('meta[name="twitter:title"]', 'content', title);
    setTag('meta[property="og:description"]', 'content', DESC);
    setTag('meta[name="twitter:description"]', 'content', DESC);
  }, [title, path]);
}
